import {Link} from "@inertiajs/react";
import {
  Button,
  Menu,
  Text,
  UnstyledButton
} from "@mantine/core";
import {PropsWithChildren} from "react";

import "./../style.css";

const topMenuButtonStyle = {
  fontFamily: "Darker Grotesque",
  fontSize: "20px",
  padding: "8px",
} as const;

const dropdownMenuItemStyle = {
  fontFamily: "Darker Grotesque",
  fontSize: "16px",
} as const;

export default function Guest({ children }: PropsWithChildren) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <div
        className={
          "w-full bg-white min-h-[110px] flex flex-col sm:flex-row justify-between items-center px-4"
        }
      >
        <div className={"flex justify-start w-full sm:w-1/5"}>
          <a href="https://profilii.hu">
            <div
              style={{
                backgroundImage:
                  "url(https://profilii.hu/wp-content/themes/profilii/includes/img/pro_filii_logo.png)",
              }}
              className="w-[241px] h-[60px] bg-contain bg-no-repeat"
            ></div>
          </a>
        </div>
        <div className={"flex w-full sm:flex-1 gap-5 justify-center flex-wrap text-[#1b1464] text-[20px] font-bold [&_a]:text-inherit"}>
          <Menu position="bottom-start">
            <Menu.Target>
              <UnstyledButton
                className="uppercase"
                style={topMenuButtonStyle}
              >
                Rólunk
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <a href="https://profilii.hu/#bemutatkozas/">Alapítvány</a>
              </Menu.Item>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <a href="https://profilii.hu/#kuratorium">Kuratórium</a>
              </Menu.Item>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <a href="https://profilii.hu/#biralobizottsag">
                  Bírálóbizottság
                </a>
              </Menu.Item>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <a href="https://profilii.hu/a-meszaros-csoportrol/">
                  Mészáros csoport
                </a>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          <Menu position="bottom-start">
            <Menu.Target>
              <UnstyledButton
                className="uppercase"
                style={topMenuButtonStyle}
              >
                Pályázóknak
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <a href="https://profilii.hu/palyazati-kiiras/">
                  Pályázati kiírás
                </a>
              </Menu.Item>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <a href="https://profilii.hu/regisztracio/">Regisztráció</a>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
          <Menu>
            <Menu.Target>
              <UnstyledButton
                className="uppercase"
                style={topMenuButtonStyle}
              >
                <a href="https://profilii.hu/hirek/">Hírek</a>
              </UnstyledButton>
            </Menu.Target>
          </Menu>
          <Menu>
            <Menu.Target>
              <UnstyledButton
                className="uppercase"
                style={topMenuButtonStyle}
              >
                <a href="https://profilii.hu/gyik/">GYIK</a>
              </UnstyledButton>
            </Menu.Target>
          </Menu>
          <Menu position="bottom-start">
            <Menu.Target>
              <UnstyledButton
                className="uppercase"
                style={topMenuButtonStyle}
              >
                Nyertesek
              </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <Menu trigger="hover" position="right">
                  <Menu.Target>
                    <Menu.Item
                      className="uppercase font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      2022
                    </Menu.Item>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#1magan">
                        I. pályázati ciklus – Támogatott magán pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#1szervezet">
                        I. pályázati ciklus – Támogatott szervezeti pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#2magan">
                        II. pályázati ciklus – Támogatott magán pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#2szervezet">
                        II. pályázati ciklus – Támogatott szervezeti pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#3magan">
                        III. pályázati ciklus – Támogatott magán pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#3szervezet">
                        III. pályázati ciklus – Támogatott szervezeti pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#4magan">
                        IV. pályázati ciklus – Támogatott magán pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#4szervezet">
                        IV. pályázati ciklus – Támogatott szervezeti pályázatok
                      </a>
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Menu.Item>
              <Menu.Item
                className="uppercase font-bold"
                style={dropdownMenuItemStyle}
              >
                <Menu trigger="hover" position="right">
                  <Menu.Target>
                    <Menu.Item
                      className="uppercase font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      2023
                    </Menu.Item>
                  </Menu.Target>
                  <Menu.Dropdown>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#5magan">
                        I. pályázati ciklus – Támogatott magán pályázatok
                      </a>
                    </Menu.Item>
                    <Menu.Item
                      className="font-bold"
                      style={dropdownMenuItemStyle}
                    >
                      <a href="https://profilii.hu/nyertesek/#5szervezet">
                        I. pályázati ciklus – Támogatott szervezeti pályázatok
                      </a>
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>

          <Menu>
            <Menu.Target>
              <UnstyledButton
                className="uppercase"
                style={topMenuButtonStyle}
              >
                <a href="https://profilii.hu/#">Keresés</a>
              </UnstyledButton>
            </Menu.Target>
          </Menu>
        </div>
        <div className={"flex justify-end w-full sm:w-1/5"}>
          <Button className="px-10! h-12! bg-brand-700!">
            <Text className=" uppercase font-bold! hover:text-[#0a58ca]">
              Belépés
            </Text>
          </Button>
        </div>
      </div>
      <div className={"flex flex-col sm:justify-center items-center pt-6 sm:pt-0 grow sm:mb-[110px]"}>
        <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
          {children}
        </div>

        <div
          onClick={() => window.location.replace("https://profilii.hu/")}
          className="cursor-pointer mt-6 underline text-sm text-gray-600 hover:text-gray-900 rounded-md focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-brand-700"
        >
          Vissza a profilii.hu oldalra
        </div>
      </div>

    </div>
  );
}
